import type { FieldValues } from "react-hook-form";
import { usStateOrTerritoryOptions } from "../../../constants";
import { FormDropdown, type FormDropdownProps } from "./FormDropdown";

const abbreviatedStateOptions = usStateOrTerritoryOptions.map((option) => ({
	value: option.value,
	label: option.value,
}));

export type FormStateDropdownProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = Omit<FormDropdownProps<TFieldValues, TTransformedValues>, "options"> & {
	abbreviate?: boolean;
};

export const FormStateDropdown = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>({
	abbreviate = false,
	placeholder = abbreviate ? "Select" : "Select one",
	optionsClassName = "max-h-[35vh]",
	...props
}: FormStateDropdownProps<TFieldValues, TTransformedValues>) => {
	return (
		<FormDropdown
			{...props}
			options={abbreviate ? abbreviatedStateOptions : usStateOrTerritoryOptions}
			placeholder={placeholder}
			optionsClassName={optionsClassName}
		/>
	);
};
